import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { Grid, Typography } from "@mui/material";

import Paper from "./Paper";
import { colors } from "../pages/css components/Style";

const PageName = styled(Typography)`
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
  color: #fff;
`;

export default function SubNavbar({
  pageName,
  title,
  icons = [],
  buttons = [],
}) {
  return (
    <Fragment>
      <Helmet title={title || pageName} />
      <Paper style={{ background: colors.sprintexBlue, padding: "10px" }}>
        <Grid size="auto" style={{ alignSelf: "center" }}>
          <PageName>{pageName}</PageName>
        </Grid>

        <Grid size="auto" offset={{ sm: "auto" }} />

        <Grid size="auto" style={{ gap: "4px" }}>
          {icons.length > 0 &&
            icons.map((icon, index) => <Fragment key={index}>{icon}</Fragment>)}

          {buttons.length > 0 &&
            buttons.map((icon, index) => (
              <Fragment key={index}>{icon}</Fragment>
            ))}
        </Grid>
      </Paper>
    </Fragment>
  );
}
